import { render, staticRenderFns } from "./CAxASCxClarificationsPage.vue?vue&type=template&id=09dda80c"
import script from "./CAxASCxClarificationsPage.vue?vue&type=script&lang=js"
export * from "./CAxASCxClarificationsPage.vue?vue&type=script&lang=js"
import style0 from "./CAxASCxClarificationsPage.vue?vue&type=style&index=0&id=09dda80c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports